import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const formRef = useRef();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      setSubmitMessage("Please complete the CAPTCHA verification.");
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage("");

    // For Afrihost hosting, you'll need to set up a server-side script
    // This is a placeholder for the form submission
    try {
      // You'll need to replace this with your actual form handling
      // For Afrihost, you might use their PHP mail function
      const response = await fetch("/contact-form-handler.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          to: "info@spaholdings.co.za",
          captcha: captchaValue,
        }),
      });

      if (response.ok) {
        setSubmitMessage(
          "Thank you for your message! We'll get back to you soon."
        );
        setFormData({ name: "", email: "", message: "" });
        setCaptchaValue(null);
      } else {
        setSubmitMessage(
          "There was an error sending your message. Please try again."
        );
      }
    } catch (error) {
      setSubmitMessage(
        "There was an error sending your message. Please try again."
      );
    }

    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-title">
          <h2>Get in Touch</h2>
          <p>Ready to transform your business? Let's start a conversation</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Build Something Amazing Together</h3>
            <p>
              Whether you need cutting-edge AI solutions, cloud services, or
              strategic consulting, we're here to help your business thrive.
            </p>

            <div className="contact-details">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <div>
                  <h4>Email Us</h4>
                  <p>info@spaholdings.co.za</p>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">🌍</span>
                <div>
                  <h4>Location</h4>
                  <p>South Africa</p>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">⏰</span>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 8:00 AM - 5:00 PM SAST</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form
              ref={formRef}
              onSubmit={handleSubmit}
              className="contact-form"
            >
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Your Email"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Your Message"
                  rows="5"
                  className="form-input"
                ></textarea>
              </div>

              <div className="form-group">
                <ReCAPTCHA
                  sitekey="6Le7ppMrAAAAAGJ-HX6LGsrNnGDb3N_KN91K6b_B"
                  onChange={handleCaptchaChange}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>

              {submitMessage && (
                <div
                  className={`submit-message ${
                    submitMessage.includes("error") ? "error" : "success"
                  }`}
                >
                  {submitMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
